import axios from "axios";

const domain = window.location.hostname;
let baseURL;
let apiKey;
if (domain === "127.0.0.1" || domain === "localhost") {
    baseURL = "http://127.0.0.1:8001/api";
    // baseURL = "https://uatapi.goerone.com/api";
    apiKey = "F4yYTHir2gkdhUjG7JGM8AMerjxUqZF4Cyy7aKT4XmXGuKILo4AddlnuVwMycMw7w11OZd9RA8STgF9o";
    // baseURL = "https://uatapi.goerone.com/api";
} else if (domain === "admin.goertrip.club" || domain === "www.admin.goertrip.club") {
    baseURL = "https://api.ozilconnect.com/api";
    apiKey = "2Iy4xlJpvrYsrOl4jzlgSn1RizVfz6JCBZwvDggzAFG3mOc7m9ZxkpnA6947E69yRrjgDOxJ76ugzMaa";
} else if (domain === "admin.holidayfly.in" || domain === "www.admin.holidayfly.in") {
    baseURL = "https://api.ozilconnect.com/api";
    apiKey = "X3xQydrVeevUP7Zs2MeIjc9P2NlngnCH98FTU2YqboYOmQsXyzUTxMYK3oQC";
} else if (domain === "admin.ozilcrm.com" || domain === "www.admin.ozilcrm.com") {
    baseURL = "https://uatapi.goerone.com/api";
    apiKey = "F4yYTHir2gkdhUjG7JGM8AMerjxUqZF4Cyy7aKT4XmXGuKILo4AddlnuVwMycMw7w11OZd9RA8STgF9o";
} else {
    baseURL = "http://127.0.0.1:8081/api";
    apiKey = "F4yYTHir2gkdhUjG7JGM8AMerjxUqZF4Cyy7aKT4XmXGuKILo4AddlnuVwMycMw7w11OZd9RA8STgF9o";
}
export function getbaseURL() {
    return baseURL;
}

export function getApiKey() {
    return apiKey;
}

const api = axios.create({
    // baseURL: "http://127.0.0.1:8081/api",
    // baseURL: "https://api.ozilconnect.com/api",
    baseURL: baseURL,
});

// Add a request interceptor to include the auth token
api.interceptors.request.use(
    (config) => {
        const isGoerOneLoginCall = config.url?.includes("/GoerOne/login");
        const isCityServiceCall = config.url?.includes("/loyalty/city-service");
        const isNearbyStore = config.url?.includes("/store/search");
        const isCategories = config.url?.includes("/store/fetch-store-categories");
        // const isStoreDetails = config.url?.includes("/loyalty/store-reward-vouchers");
        const isStoreAdminLogin = config.url?.includes("/store/login");
        if (isGoerOneLoginCall || isCityServiceCall || isNearbyStore || isCategories || isStoreAdminLogin) {
            // Treat like the public /login endpoint — always apiKey, never a Bearer token
            config.headers.Authorization = `Bearer ${apiKey}`;
            return config;
        }

        if (window.location.pathname.startsWith("/store-panel")) {
            let storeToken = null;
            try { storeToken = JSON.parse(localStorage.getItem("store_panel_auth"))?.token; } catch { /* ignore */ }
            if (storeToken) {
                config.headers.Authorization = `Bearer ${storeToken}`;
            } else {
                config.headers.apiKey = apiKey;
            }
            return config;
        }

        const isGoerOneWeb = window.location.pathname.startsWith("/web/");
        const goeroneToken = isGoerOneWeb ? sessionStorage.getItem("goerone_test_token") : null;
        const token = goeroneToken || localStorage.getItem("token");
        // const token = localStorage.getItem("token");
        // console.log(token);
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            config.headers.apiKey = apiKey;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// export const login = async (credentials) => {
//   try {
//     const response = await api.post('/login', credentials);
//     console.log(response.data);

//     return response.data;
//   } catch (error) {
//     throw error.response.data;
//   }
// };

export const login = async (credentials) => {
    try {
        const response = await api.post("/login", credentials);
        return response.data;
    } catch (error) {
        // Handle 401 Unauthorized (Invalid Credentials)
        if (error.response && error.response.status === 401) {
            throw {
                status: false,
                httpStatus: 401,
                message: error.response.data.message || "Invalid Credentials",
            };
        }
        // Handle other errors
        throw {
            status: false,
            httpStatus: error.response?.status || 500,
            message: error.response?.data?.message || "Login failed. Please try again.",
        };
    }
};

export const getProfile = async () => {
    try {
        const response = await api.get("/user");
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const logout = async () => {
    try {
        await api.post("/logout");
    } catch (error) {
        console.error("Logout error:", error);
    }
};

export const createuser = async (credentials) => {
    try {
        const response = await api.post("/customer/create", credentials);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        // Handle 401 Unauthorized (Invalid Credentials)
        if (error.response && error.response.status === 401) {
            throw {
                status: false,
                httpStatus: 401,
                message: error.response.data.message || "Invalid Credentials",
            };
        }
        // Handle other errors
        throw {
            status: false,
            httpStatus: error.response?.status || 500,
            message: error.response?.data?.message || "Something went Wrong. Please try again.",
        };
    }
};

export const getUserlist = async (perPage, page = 1, keyword = null, userIds = []) => {
    try {
        const response = await api.post(`/customer/fetch?per_page=${perPage}&page=${page}&keyword=${keyword}`, {
            userIds: userIds,
        });
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const getLoyaltyCard = async (perPage, page = 1, cardNumbers = []) => {
    try {
        const response = await api.post(
            `/loyalty/loyalty_card?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
            }
        );
        // const response = await api.post(`/loyalty/loyalty_card?per_page=${perPage}&page=${page}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getLoyaltyCardUnAssign = async (perPage, page = 1, cardNumbers = [], keyword = null) => {
    try {
        const response = await api.post(
            `/loyalty/loyalty_card_unassign?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
                keyword: keyword,
            }
        );
        // const response = await api.post(`/loyalty/loyalty_card?per_page=${perPage}&page=${page}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getLoyaltyUserCard = async (perPage, page = 1, cardNumbers = [], Filter = []) => {
    try {
        const response = await api.post(
            `/loyalty/user_card?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
                Filter: Filter,
            }
        );
        //const response = await api.post(`/loyalty/user_card?per_page=${perPage}&page=${page}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const getServices = async () => {
    try {
        const response = await api.post(`/tickets/services`);
        return response;
    } catch (error) {
        if (error?.response?.data?.httpStatus === 401 && error?.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error?.response?.data;
    }
};

export const getLoyaltyRewards = async (perPage, page = 1, created_by = 'all', status = 'all',keyword = '') => {
    try {
        const response = await api.post(
            `/loyalty/reward?per_page=${perPage}&page=${page}`,
            { created_by, status,keyword }
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const getvoucherlist = async (perPage, page = 1) => {
    try {
        const response = await api.post(`/voucher/voucher-list?per_page=${perPage}&page=${page}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getLoyaltyRedemption = async (perPage, page = 1) => {
    try {
        const response = await api.post(`/loyalty/redemptionhistory?per_page=${perPage}&page=${page}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getLoyaltyProgram = async () => {
    try {
        const response = await api.post(`/loyalty/program`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};


export const getMembershipList = async (perPage, page = 1, keyword = null, is_active = null) => {
    try {
        const response = await api.post(
            `/loyalty/membership?per_page=${perPage}&page=${page}`, // URL with query params
            {
                keyword: keyword,
                is_active: is_active,
            }
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const saveMembership = async (details) => {
    try {
        const response = await api.post("/loyalty/savemembership", details);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const toggleMembershipStatus = async (program_id) => {
    try {
        const response = await api.post(`/loyalty/membership/${program_id}/togglestatus`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};


export const creatLoyalitycard = async (details) => {
    try {
        const response = await api.post("/loyalty/addcard", details);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const creatLoyalityReward = async (details) => {
    try {
        const response = await api.post("/loyalty/addreward", details);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const creatVoucher = async (details) => {
    try {
        const response = await api.post("/voucher/add", details);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const creatLoyalityRewardParent = async (reward_id) => {
    try {
        const response = await api.post("/loyalty/rewardparent/" + reward_id);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const creatLoyalityAssign = async (details) => {

    try {
        const response = await api.post("/loyalty/assign", details);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const creatstore = async (details) => {
    try {
        const response = await api.post("/store/create", details, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        // Handle 401 Unauthorized (Invalid details)
        if (error.response && error.response.status === 401) {
            throw {
                status: false,
                httpStatus: 401,
                message: error.response.data.message || "Invalid details",
            };
        }
        // Handle other errors
        throw {
            status: false,
            httpStatus: error.response?.status || 500,
            message: error.response?.data?.message || "Something went Wrong. Please try again.",
        };
    }
};

export const importcustomer = async (details) => {
    try {
        const response = await api.post("/customer/importcustomer", details);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        // Handle 401 Unauthorized (Invalid details)
        if (error.response && error.response.status === 401) {
            throw {
                status: false,
                httpStatus: 401,
                message: error.response.data.message || "Invalid details",
            };
        }
        // Handle other errors
        throw {
            status: false,
            httpStatus: error.response?.status || 500,
            message: error.response?.data?.message || "Something went Wrong. Please try again.",
        };
    }
};

export const fetchstores = async (perPage, page = 1, keyword = null) => {
    try {
        const response = await api.post(`/store/fetch?per_page=${perPage}&page=${page}&keyword=${keyword}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};

// Single endpoint backing both flows:
// - pass `city` for an exact serviceability check (auto-detect only)
// - pass `keyword`/`limit` (city omitted) to search/list store-backed cities
export const cityService = async ({ city = "", state = "", country = "", keyword = "", limit = 5 } = {}) => {
    try {
        const response = await api.post("/loyalty/city-service", { city, state, country, keyword, limit });
        return response.data;
    } catch (error) {
        if (error.response?.data?.httpStatus === 401 && error.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw (
            error.response?.data || {
                status: { success: false, httpStatus: 500 },
                message: "Something went Wrong. Please try again.",
            }
        );
    }
};

// (d) remove a single gallery image (multi store image upload, up to 5)
export const removeStoreImage = async (imageId) => {
    try {
        const response = await api.post(`/store/remove-image/${imageId}`);
        return response.data;
    } catch (error) {
        if (error.response?.data?.httpStatus === 401 && error.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw (
            error.response?.data || {
                status: { success: false, httpStatus: 500 },
                message: "Something went Wrong. Please try again.",
            }
        );
    }
};

export const fetchstorecategories = async () => {
    try {
        const response = await api.post("/store/fetch-store-categories");
        return response.data;
    } catch (error) {
        if (error.response?.data?.httpStatus === 401 && error.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw (
            error.response?.data || {
                status: { success: false, httpStatus: 500 },
                message: "Something went Wrong. Please try again.",
            }
        );
    }
};

export const fetchcountries = async () => {
    try {
        const response = await api.post(`/country`);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};
export const fetchstates = async (value) => {
    try {
        const response = await api.post("/states", { countryid: value });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const fetchcities = async (stateid, countryid) => {
    try {
        const response = await api.post("/cities", { stateid: stateid, countryid: countryid });
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const getLoyaltyReport = async (perPage, page = 1, cardNumbers = []) => {
    try {
        const response = await api.post(
            `/loyalty/redemptionreport?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
            }
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getLoyaltyReportCustomer = async (perPage, page = 1, cardNumbers = []) => {
    try {
        const response = await api.post(
            `/loyalty/redemptionreportcustomer?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
            }
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getLoyaltyReportReward = async (perPage, page = 1, cardNumbers = []) => {
    try {
        const response = await api.post(
            `/loyalty/redemptionreportreward?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
            }
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getEarningByCustomer = async (perPage, page = 1, filters = []) => {
    try {
        const response = await api.post(
            `/loyalty/earningbycustomer?per_page=${perPage}&page=${page}`, // URL with query params
            {
                filters: filters,
            }
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const CompareFaces = async (imageData) => {
    try {
        const response = await api.post("/customer/face-compare", imageData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const SendPasswordAPI = async (id) => {
    try {
        const response = await api.post(`/manage-user/sendpassword/${id}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getproducts = async (perPage, page = 1, cardNumbers = []) => {
    try {
        const response = await api.post(
            `/products/fetch?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
            }
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getordersHistory = async (perPage, page = 1, cardNumbers = []) => {
    try {
        const response = await api.post(
            `/products/orders_history?per_page=${perPage}&page=${page}`, // URL with query params
            {
                cardNumbers: cardNumbers,
            }
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getordersStatusLog = async (order_id) => {
    try {
        const response = await api.post(
            `/products/orders_status_log/${order_id}`, // URL with query params
        );
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const updateProductPost = async (productData) => {
    try {
        const response = await api.post(
            `/products/create`, // Adjust endpoint as per your backend
            productData
        );
        return response.data;
    } catch (error) {
        if (error?.response?.data?.httpStatus === 401 && error?.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const updateOrderStatus = async (formData) => {
    try {
        const response = await api.post(
            `/products/create_order_status`, // Adjust endpoint as per your backend
            formData
        );
        return response.data;
    } catch (error) {
        if (error?.response?.data?.httpStatus === 401 && error?.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};
export const getProductInfo = async (id) => {
    try {
        const response = await api.post(`/products/fetchproductinfo/${id}`, {});
        return response.data;
    } catch (error) {
        if (error.response?.data?.httpStatus === 401 && error.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
    }
};
export const getProductDetails = async (id) => {
    try {
        const response = await api.post(`/products/fetchproductdetails/${id}`, {});
        return response.data;
    } catch (error) {
        if (error.response?.data?.httpStatus === 401 && error.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
    }
};
export const saveProductDetails = async (id, productDetailsData) => {
    try {
        const response = await api.post(`/products/createproductdetails/${id}`, productDetailsData);
        return response.data;
    } catch (error) {
        if (error.response?.data?.httpStatus === 401 && error.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response?.data || error;
    }
};
export const deleteProduct = async (productId) => {
    try {
        const response = await api.post(`/products/deleteproducts/${productId}`);
        return response.data;
    } catch (error) {
        if (error.response?.data?.httpStatus === 401 && error.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response?.data || error;
    }
};
export const getProductImages = async (productId) => {
    const response = await api.get(`/products/fetchimages/${productId}`);
    return response;
};

export const saveProductImages = async (productId, formData) => {
    const response = await api.post(`/products/saveimages/${productId}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response;
};

export const getProductAddresses = async (productId) => {
    const response = await api.get(`/products/fetchaddresses/${productId}`);
    return response;
};

export const saveProductAddresses = async (productId, payload) => {
    const response = await api.post(`/products/saveaddresses/${productId}`, payload);
    return response;
};

const handleLedgerError = (error) => {
    if (error?.response?.data?.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
        window.location.reload();
    }
    throw error?.response?.data || error;
};

// payload: { customer_id, bookingID, FromDate, ToDate, mode }
export const getRewardLedger = async (perPage = 50, page = 1, payload = {}) => {
    try {
        const response = await api.post(`/reward/reward-ledger?per_page=${perPage}&page=${page}`, payload);
        return response.data;
    } catch (error) {
        handleLedgerError(error);
    }
};

// ASSUMPTION: the pending endpoint path is not final – change it here when you have it.
export const getRewardLedgerPending = async (perPage = 50, page = 1, payload = {}) => {
    try {
        const response = await api.post(`/reward/reward-ledger-temp?per_page=${perPage}&page=${page}`, payload);
        return response.data;
    } catch (error) {
        handleLedgerError(error);
    }
};

// admin (for the review screen later)
export const getMembershipInvites = async ({ perPage = 25, page = 1, status = null, programId = null, keyword = null } = {}) => {
    try {
        const response = await api.post(`/loyalty/membership-invites?page=${page}`, {
            per_page: perPage, status, program_id: programId, keyword,
        });
        return response.data;
    } catch (error) {
        if (error.response?.data?.httpStatus === 401 && error.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response?.data;
    }
};

export const reviewMembershipInvite = async (id, action, rejectionReason = null) => {
    try {
        const response = await api.post(`/loyalty/membership-invites/${id}/review`, {
            action, rejection_reason: rejectionReason,
        });
        return response.data;
    } catch (error) {
        throw error.response?.data;
    }
};


// ---- Reward approvals (store-created rewards) ----
// payload: { status: 'pending' | 'rejected' | 'approved' | 'all', per_page, page }
export const fetchRewardApprovals = async ({ status = "pending", perPage = 20, page = 1 } = {}) => {
    try {
        const response = await api.post(`/loyalty/reward-approval-list?per_page=${perPage}&page=${page}`, { status, per_page: perPage });
        return response.data;
    } catch (error) {
        if (error.response?.data?.httpStatus === 401 && error.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response?.data || { status: { success: false, httpStatus: 500 }, message: "Something went Wrong. Please try again." };
    }
};

export const approveLoyaltyReward = async (rewardId) => {
    try {
        const response = await api.post("/loyalty/reward-approve", { reward_id: rewardId });
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: { success: false, httpStatus: 500 }, message: "Unable to approve reward. Please try again." };
    }
};

export const deactivateLoyaltyReward = (reward_id) => {
    try {
        const response = api.post('/loyalty/rewards/deactivate', { reward_id });
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: { success: false, httpStatus: 500 }, message: "Unable to approve reward. Please try again." };
    }
};

export const rejectLoyaltyReward = async (rewardId, rejectReason) => {
    try {
        const response = await api.post("/loyalty/reward-reject", { reward_id: rewardId, reject_reason: rejectReason });
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: { success: false, httpStatus: 500 }, message: "Unable to reject reward. Please try again." };
    }
};

export const reviewVoucher = async (payload) => {
    try {
        const response = await api.post("/voucher/review", payload);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
};

export const getvoucherapprovals = async (perPage, page, status = 0) => {
    try {
        const response = await api.post(`/voucher/approvals?per_page=${perPage}&page=${page}&status=${status}`);
        return response.data;
    } catch (error) {
        if (error.response.data.httpStatus === 401 && error.response.data.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response.data;
    }
}

// ---- Member reports (append to services/api.js; handleLedgerError is already defined there) ----

// payload: { from_date, to_date, program_id, status }
export const getPaidMembersTierReport = async (payload = {}) => {
    try {
        const response = await api.post("/report/paid-members-tier", payload);
        return response.data;
    } catch (error) {
        handleLedgerError(error);
    }
};

// drill-down (paginated). payload: same as above + keyword
export const getPaidMembersList = async (perPage = 25, page = 1, payload = {}) => {
    try {
        const response = await api.post(`/report/paid-members-tier/members?per_page=${perPage}&page=${page}`, payload);
        return response.data;
    } catch (error) {
        handleLedgerError(error);
    }
};

// returns the full axios response (blob) so the caller can read the file name header
export const exportPaidMembers = async (payload = {}) => {
    try {
        return await api.post("/report/paid-members-tier/export", payload, { responseType: "blob" });
    } catch (error) {
        handleLedgerError(error);
    }
};

// payload: { from_date, to_date, membership: active|expired|none, keyword }
export const getRegisteredMembers = async (perPage = 25, page = 1, payload = {}) => {
    try {
        const response = await api.post(`/report/registered-members?per_page=${perPage}&page=${page}`, payload);
        return response.data;
    } catch (error) {
        handleLedgerError(error);
    }
};

export const exportRegisteredMembers = async (payload = {}) => {
    try {
        return await api.post("/report/registered-members/export", payload, { responseType: "blob" });
    } catch (error) {
        handleLedgerError(error);
    }
};

// ---- Performance reports (append to services/api.js; reuses handleLedgerError) ----
const postReport = async (url, payload, config) => {
    try {
        return await api.post(url, payload, config);
    } catch (error) {
        handleLedgerError(error); // always throws
    }
};

// Activation rate. payload: { from_date, to_date, state }
export const getActivationReport = async (payload = {}) => (await postReport("/report/activation", payload)).data;
export const getActivationMembers = async (perPage = 25, page = 1, payload = {}) =>
    (await postReport(`/report/activation/members?per_page=${perPage}&page=${page}`, payload)).data;
export const exportActivation = (payload = {}) => postReport("/report/activation/export", payload, { responseType: "blob" });

// Active members who transacted in the last N days. payload: { days, program_id, state }
export const getActiveTransactors = async (payload = {}) => (await postReport("/report/active-transactors", payload)).data;
export const getTransactorMembers = async (perPage = 25, page = 1, payload = {}) =>
    (await postReport(`/report/active-transactors/members?per_page=${perPage}&page=${page}`, payload)).data;
export const exportTransactors = (payload = {}) => postReport("/report/active-transactors/export", payload, { responseType: "blob" });

// Commission collected vs earned. payload: { from_date, to_date, group_by, settlement_status }
export const getCommissionReport = async (payload = {}) => (await postReport("/report/commission", payload)).data;
export const getCommissionLedger = async (perPage = 25, page = 1, payload = {}) =>
    (await postReport(`/report/commission/ledger?per_page=${perPage}&page=${page}`, payload)).data;
export const exportCommission = (payload = {}) => postReport("/report/commission/export", payload, { responseType: "blob" });


//------------------------- goerone web apis -----------------------------

// Single call for both the "discover" (city + category, cursor-paged) and
// "nearby" (lat/lon + radius, offset-paged, distance-sorted) store feeds —
// the backend dispatches on `mode`. Pass only the params the chosen mode
// needs; the other side's params are ignored server-side.
export const fetchStoresNearby = async ({
    mode,
    city,
    lat,
    lon,
    radius = 40,
    category = "",
    cursor = null,
    offset = 0,
    limit = 15,
}) => {
    try {
        const payload =
            mode === "nearby"
                ? { mode, lat, lon, radius, category, offset, limit }
                : { mode: "discover", city, category, cursor, limit, lat, lon };
        const response = await api.post("/store/search", payload);
        return response.data;
    } catch (error) {
        if (error.response?.data?.httpStatus === 401 && error.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response?.data || {
            status: { success: false, httpStatus: 500 },
            message: "Something went Wrong. Please try again.",
        };
    }
};

export const getStoreDetails = async (
    storeId,
    { rewardPerPage = 25, rewardPage = 1, voucherPerPage = 25, voucherPage = 1 } = {}
) => {
    try {
        const response = await api.post("/loyalty/store-reward-vouchers", {
            stores_id: storeId,
            reward_per_page: rewardPerPage,
            reward_page: rewardPage,
            voucher_per_page: voucherPerPage,
            voucher_page: voucherPage,
        });
        return response.data;
    } catch (error) {
        if (error.response?.data?.httpStatus === 401 && error.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw (
            error.response?.data || {
                status: { success: false, httpStatus: 500 },
                message: "Something went Wrong. Please try again.",
            }
        );
    }
};

export const goeroneTestLogin = async (payload) => {
    try {
        const response = await api.post("/GoerOne/login", payload);
        return response.data;
    } catch (error) {
        throw error.response?.data || {
            status: false,
            message: "Test login failed. Please try again.",
        };
    }
};

export const isApiSuccess = (res) => res?.status === true || res?.status?.success === true;

export const sendOtp = async (phone) => {
    try {
        const response = await api.post("/sms/sendotp", { phone, purpose: "otp" });
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: { success: false, httpStatus: 500 }, message: "Unable to send OTP. Please try again." };
    }
};

export const verifyOtp = async (phone, otp) => {
    try {
        const response = await api.post("/sms/verifyotp", { phone, otp });
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: { success: false, httpStatus: 500 }, message: "Unable to verify OTP. Please try again." };
    }
};

export const redeemOrder = async (payload) => {
    try {
        const response = await api.post("/loyalty/redeem", payload);
        return response.data;
    } catch (error) {
        if (error.response?.data?.httpStatus === 401 && error.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response?.data || {
            status: { success: false, httpStatus: 500 },
            message: "Your order could not be completed. Please try again.",
        };
    }
};

export const getRedeemDetails = async (referenceNo) => {
    try {
        const response = await api.post("/loyalty/redeem-details", { referneceNo: referenceNo });
        return response.data;
    } catch (error) {
        if (error.response?.data?.httpStatus === 401 && error.response?.data?.message === "Unauthenticated") {
            window.location.reload();
        }
        throw error.response?.data || {
            status: { success: false, httpStatus: 500 },
            message: "Unable to load payment details. Please try again.",
        };
    }
};

export const addVoucherToCart = async (voucherId, quantity) => {
    try {
        const response = await api.post("/voucher/voucher-cart", { voucher_id: voucherId, quantity });
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: { success: false, httpStatus: 500 }, message: "Unable to add voucher to cart." };
    }
};

export const updateVoucherCartQty = async (voucherId, quantity) => {
    try {
        const response = await api.put(`/voucher/voucher-cart/${voucherId}`, { quantity });
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: { success: false, httpStatus: 500 }, message: "Unable to update cart." };
    }
};

export const removeVoucherFromCart = async (voucherId) => {
    try {
        const response = await api.delete(`/voucher/voucher-cart/${voucherId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: { success: false, httpStatus: 500 }, message: "Unable to remove voucher from cart." };
    }
};

export const checkoutVoucherCart = async (payload = {}) => {
    try {
        const response = await api.post("/voucher/voucher-checkout", payload);
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: false, message: "Unable to place voucher order. Please try again." };
    }
};

export const purchaseVoucherOrder = async (payload) => {
    try {
        const response = await api.post("/voucher/voucher-purchase", payload);
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: false, message: "Your voucher order could not be completed. Please try again." };
    }
};

export const getVoucherOrder = async (orderNo) => {
    try {
        const response = await api.get(`/voucher/voucher-orders/${encodeURIComponent(orderNo)}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: false, message: "Unable to load your voucher order." };
    }
};

export const getMyVouchers = async (page = 1) => {
    try {
        const response = await api.get("/voucher/my-vouchers", { params: { page } });
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: false, message: "Unable to load your vouchers. Please try again." };
    }
};

// PAN check. Same host as the rest of the API (uatapi.goerone.com/api/pan-verify)
export const verifyPan = async (pan, customerId) => {
    try {
        const response = await api.post("/pan-verify", { pan, customer_id: customerId });
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: false, message: "Unable to verify PAN. Please try again." };
    }
};

export const requestMembershipConsideration = async (payload) => {
    try {
        const response = await api.post("/loyalty/membership-invite/request", payload);
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: { success: false, httpStatus: 500 }, message: "Unable to send your request. Please try again." };
    }
};

export const getMembershipInviteStatus = async (programId) => {
    try {
        const response = await api.get(`/loyalty/membership-invite/status/${programId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: { success: false, httpStatus: 500 }, message: "Unable to check your request." };
    }
};

export const validateVoucher = async (payload) => {
    try {
        const response = await api.post("/voucher/voucher-validate", payload);
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: false, message: "Unable to validate voucher. Please try again." };
    }
};

//Store Login and its apis

export const storeAdminLogin = async (email, admin, password) => {
    try {
        const response = await api.post("/store/login", { admin, email, password });
        return response.data;
    } catch (error) {
        throw error.response?.data || {
            status: { success: false, httpStatus: 500 },
            message: "Unable to login to store. Please try again.",
        };
    }
};

// Approve a pending (temp) reward ledger entry
// payload (multipart): { ledger_id, uploaded_bill? }
export const approveTempReward = async (ledgerId, bill = null) => {
    try {
        const formData = new FormData();
        formData.append("ledger_id", ledgerId);
        if (bill) formData.append("uploaded_bill", bill);

        const response = await api.post("/reward/temp-reward-processed", formData);
        return response.data;
    } catch (error) {
        handleLedgerError(error);
    }
};

// Reject a pending (temp) reward ledger entry
// Same endpoint as approve; payload: { ledger_id, remarks, is_rejected: true }
export const rejectTempReward = async (ledgerId, remarks) => {
    try {
        const response = await api.post("/reward/temp-reward-processed", {
            ledger_id: ledgerId,
            remarks,
            is_rejected: true,
        });
        return response.data;
    } catch (error) {
        handleLedgerError(error);
    }
};

// payload: { customer_id, referneceNo, FromDate, ToDate }
export const getStoreRedemptionLedger = async (perPage = 25, page = 1, payload = {}) => {
    try {
        const response = await api.post(`/loyalty/storeredemptionledger?per_page=${perPage}&page=${page}`, payload);
        return response.data;
    } catch (error) {
        handleLedgerError(error);
    }
};

export const redeemVoucherCode = async (payload) => {
    try {
        const response = await api.post("/voucher/voucher-redemption", payload);
        return response.data;
    } catch (error) {
        throw error.response?.data || { status: false, message: "Unable to redeem voucher. Please try again." };
    }
};


// ---- Store bill QR (store-pay) ----
// create: payload { store_id, amount, reference } -> { payment: {...}, qr: { sid, amt, tm, ref } }
export const createStorePayment = async (payload) => {
    try {
        const response = await api.post("/store-pay/create", payload);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Unable to create the bill. Please try again." };
    }
};

// store side: check whether the customer has initiated / completed the payment
export const getStorePaymentStatus = async (reference) => {
    try {
        const response = await api.get(`/store-pay/status/${encodeURIComponent(reference)}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Unable to check the payment status." };
    }
};

// customer side: called when the customer taps Pay on the scanned bill
export const initiateStorePayment = async (reference) => {
    try {
        const response = await api.post("/store-pay/initiate", { reference });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Unable to start the payment. Please try again." };
    }
};

// customer side: turn a scanned permanent store QR handle (e.g. store-42@goerone) into the store it belongs to
// -> { status: { success }, data: { store_id, store_name, qr_handle } }
export const resolveStoreQrHandle = async (handle) => {
    try {
        const response = await api.get(`/store-pay/resolve/${encodeURIComponent(handle)}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Unable to open this QR. Please try again." };
    }
};

// admin: switch a store between active / inactive -> { status: { success }, data: { id, is_active } }
export const setStoreActiveStatus = async (id) => {
    try {
        const response = await api.post("/store/toggle-status", { id });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: "Unable to change the store status. Please try again." };
    }
};

export default api;